<template>
    <div class="leftPage">
        <div class="search">
            <el-input
                type="text"
                style="width:250px"
                :placeholder="$t('public.please_enter')"
                v-model="filterText"
                clearable
            ></el-input>
            <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
        </div>
        <div class="tree" v-if="isShow">
            <trees :treedata="treeData" ref="tree" v-bind="$attrs" @changeNode="changeNode"></trees>
        </div>
    </div>
</template>

<script>
import bus from '@/utils/bus.js'
export default {
    name: "tree",
    data() {
        return {
            filterText: "",
            isShow: true,
            treeData: []
        }
    },
    created() {
        // 这里使用深拷贝一下
        this.treeData = JSON.parse(JSON.stringify(this.$store.getters.SchemaTree))
    },
    mounted() {
        //  重置按钮时候  树形重置
        bus.$on('initTree', () => {
            this.isShow = false;
            setTimeout(() => {
                this.isShow = true
            }, 100)
        });

        // 切换下拉状态时候树形的数据
        bus.$on('editTree', (item) => {
            // 未绑定 只展示范围 不展示节点
            if (item.way === 'unbind' || item.way === 'unknown') {
                this.treeData = this.treeData.filter(opt => {
                    if (opt.id !== 'all') {
                        this.$set(opt, 'item', []);
                        return opt;
                    }
                })
            } else {
                this.treeData = JSON.parse(JSON.stringify(this.$store.getters.SchemaTree));
            }
        })
    },
    methods: {
        searchTree() {
            this.$refs.tree.$refs.tree.filter(this.filterText);
        },
        changeNode({ label, row, children }) {
            bus.$emit('nodeClickFn', label)
        }
    }
}
</script>

<style lang="scss" scoped>
.leftPage {
    width: 300px;
    height: 100%;
    margin-right: 15px;
    border-right: 1px solid $borderColor3;
    box-sizing: border-box;
}
.search {
    width: 100%;
    height: 50px;
    padding: 10px 3px;
    border-bottom: 1px solid $borderColor3;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
.btnClass {
    min-width: 0;
    width: 40px;
    margin-left: 0px;
    margin-top: 0px;
}
.tree {
    height: calc(100% - 50px);
    background-color: antiquewhite;
    overflow: auto;
}
</style>
